import { render, staticRenderFns } from "./InvestPage.vue?vue&type=template&id=106be6b1&scoped=true"
import script from "./InvestPage.vue?vue&type=script&lang=js"
export * from "./InvestPage.vue?vue&type=script&lang=js"
import style0 from "./InvestPage.vue?vue&type=style&index=0&id=106be6b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106be6b1",
  null
  
)

export default component.exports